import { DOMArray } from "../utils/dom";
import { API } from "../utils/API";
class BigCommerceAddToCart {
    scriptTarget;
    constructor(scriptTarget) {
        this.scriptTarget = scriptTarget;
    }
    updateCartElement(count, price) {
        DOMArray('p[data-cart-quantity]').forEach(element => {
            element.setAttribute("data-cart-quantity", String(count));
        });
        DOMArray(".cart-quantity").forEach(element => {
            element.innerText = String(count);
            element.style.display = "block";
        });
    }
    async updateQTY() {
        let cart = await this.getCart();
        let itemsAmount = 0;
        cart[0].lineItems.physicalItems.forEach((product) => {
            itemsAmount += product?.quantity;
        });
        this.updateCartElement(itemsAmount, cart[0].cartAmount);
    }
    getDataToAdd(productId, variantID, quantity) {
        if (variantID) {
            return { "lineItems": [{ "quantity": quantity ?? 1, "productId": productId, 'variantId': variantID }] };
        }
        else {
            return { "lineItems": [{ "quantity": quantity ?? 1, "productId": productId }] };
        }
    }
    async addToCart(productId, setStatus, variantID, quantity) {
        setStatus('Adding');
        const dataToAdd = this.getDataToAdd(productId, variantID, quantity);
        let added;
        const cart = await this.getCart();
        if (cart.length > 0) {
            const addToCartURL = `/api/storefront/carts/${cart[0].id}/items`;
            const res = await API.post({
                url: addToCartURL,
                data: JSON.stringify(dataToAdd),
                config: {
                    headers: { "Content-Type": "application/json" }
                }
            });
            added = res.status === 200;
        }
        else {
            await this.createCart(dataToAdd);
            added = true;
        }
        if (added) {
            await this.updateQTY();
            setStatus('Added');
        }
        else {
            setStatus("Error");
        }
    }
    getCart() {
        return API.get({
            url: location.origin + "/api/storefront/carts?include=lineItems.digitalItems.options,lineItems.physicalItems.options",
            config: {
                withCredentials: true,
            },
        });
    }
    createCart(cartItems) {
        return fetch(`/api/storefront/carts`, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(cartItems),
        })
            .then(response => response.json())
            .catch(error => console.error(error));
    }
}
export { BigCommerceAddToCart };
//# sourceMappingURL=BigCommerceAddToCart.js.map